{
  "form": {
    "input_placeholder": "Добавить задачу…",
    "parseWithAi_aria": "Разобрать задачу с AI",
    "parseWithAi_title": "Привести в порядок и задать приоритет с AI",
    "priorityLabel_aria": "Приоритет задачи",
    "add": "Добавить",
    "signInForAi": "Войдите, чтобы использовать возможности AI.",
    "aiUnavailable": "AI недоступен. Попробуйте снова.",
    "saveTo": "Сохранить в",
    "saveTo_aria": "Сохранить в {{list}}",
    "saveToSynced_aria": "Сохранить в {{list}}, {{provider}}",
    "addedTo": "Добавлено в «{{list}}»",
    "addedToSynced": "Добавлено в «{{list}}» · {{provider}}",
    "show": "Показать"
  },
  "priority": {
    "Critical": "Критический",
    "High": "Высокий",
    "Medium": "Средний",
    "Low": "Низкий"
  },
  "item": {
    "edit_aria": "Редактировать задачу",
    "delete_aria": "Удалить задачу",
    "addStep": "Добавить шаг",
    "addStep_placeholder": "Добавить шаг…",
    "addStep_aria": "Добавить шаг к задаче {{task}}",
    "steps_group_aria": "Шаги задачи {{task}}",
    "steps_progress_aria": "Выполнено шагов: {{done}} из {{count}}",
    "completeSteps_aria": "{{task}}. Также завершит открытые шаги: {{count}}"
  },
  "list": {
    "title": "Задачи",
    "newListFallback": "Новый список",
    "completedMeta": "{{completed}} из {{total}} выполнено",
    "deleteConfirm": "Удалить «{{name}}»?",
    "rename_title": "Переименовать",
    "deleteList_title": "Удалить список",
    "newListName_placeholder": "Название списка…",
    "newList": "Новый список",
    "done": "Готово",
    "emptyTitle": "Задач пока нет",
    "emptySubtitle": "Добавьте задачу ниже, чтобы начать.",
    "noFilterMatch": "Нет задач, подходящих под этот фильтр.",
    "createIn": "Где создать",
    "inDestination": "в {{destination}}",
    "createIn_aria": "Создать в {{destination}}",
    "createInAccount_aria": "Создать в {{destination}}, {{email}}",
    "rhemn": "Rhemn",
    "creatingIn": "Создаём в {{destination}}…",
    "createFailed": "Не удалось создать «{{name}}» в {{destination}}.",
    "createLimit": "В {{destination}} достигнут лимит списков.",
    "keepInRhemn": "Оставить в Rhemn"
  },
  "filter": {
    "label": "Фильтр",
    "all": "Все"
  },
  "voice": {
    "mic_aria": "Добавить задачи голосом",
    "mic_title": "Произнесите задачи — они будут распределены по приоритету и времени",
    "stop_aria": "Остановить и распределить задачи",
    "recording": "Запись",
    "sorting": "Распределяем задачи…",
    "stripTitle": "Услышанные задачи",
    "stripCount": "{{checked}} из {{total}}",
    "discard": "Отменить",
    "addN": "Добавить {{count}}",
    "addZero": "Добавить",
    "adding": "Добавление…",
    "parseFallback": "Не удалось распределить — ваши слова в поле ввода.",
    "nothingHeard": "Не расслышал — попробуйте ещё раз.",
    "micDenied": "Микрофон заблокирован — разрешите в настройках.",
    "gateBody": "Произнесите задачи — по приоритету и молитвенному блоку. Входит в Pro.",
    "listen_aria": "Слушаю — произнесите задачи"
  }
}
